export class Hearing {
    public recId: number | null = 0;
    public citationRecId: string | null = null;
    public hearingDate: string | null = null;
    public hearingOfficer: string | null = null;
    public resultLetterDate: string | null = null;
    public createDateTime: Date | null = new Date();
    public userId: string | null = null;
    public hearingDecision: string | null = null;
    public hearingComments: string | null = null;
    public hearingNotifiedDate: Date | null = new Date();
    public notifiedDate: Date | null = new Date();
    public cancelledHearingFlag: boolean | null = null;
    public citationAmt: string | null = null;
    public originalCitationAmt: string | null = null;
    public hearingTimeStr: string | null = null;
    public hearingDateStr: Date | null  = new Date();
    public originalHearingDecision: string | null = null;
}
